import { cn } from "@/utils/cn";

interface PlanRecommendationNoteProps {
  className?: string;
}

export const PlanRecommendationNote = ({
  className,
}: PlanRecommendationNoteProps) => {
  return (
    <div
      className={cn(
        "text-xs text-gray-600 bg-gray-50 border border-gray-200 rounded-lg p-3 space-y-2",
        className,
      )}
    >
      <p className="font-semibold text-gray-800">
        How does NutriCoach recommend your meals?
      </p>
      <ul className="list-disc list-inside space-y-1">
        <li>
          NutriCoach considers all of your preferences to recommend meals that
          meet your tastes and calorie/macro requirements.
        </li>
        <li>
          Whenever you swap a meal, NutriCoach makes sure that the plan&apos;s
          calories and macros are always between ±10% in relation to your
          calories and macros.
        </li>
      </ul>
    </div>
  );
};
